<template>
	<div class="modal fade" :id="'alreadyOrderedModal-'+index" tabindex="-1" role="dialog">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title">Existing Orders</h1>
					<button type="button" class="close" data-dismiss="modal" aria-label="close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p class="text-left">
						These orders are already scheduled on this day:
					</p>
					<h3 v-for="(item,index) in save_day_items" :key='index'>
						{{item.description}}
					</h3>
					<hr/>
					<p class="text-center font-weight-bold">Would you like to add this order anyway?</p>
					<div class="row">
						<div class="col-6">
							<button class="btn btn-outline-danger w-100" v-on:click.prevent="no_thanks">No Thanks</button>
						</div>
						<div class="col-6">
							<button class="btn btn-primary w-100" v-on:click.prevent="yes">Proceed</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import moment from 'moment';
	const $ = window.$

	export default {
		name: 'AlreadyOrderedModal',
		props: ['activeOrderItems', 'startDate', 'index'],

		data() {
			return {
				save_day_items: null,
			}
		},

		watch: {
			startDate(val) {
				if (val && val != 'Select Start Week'){
					this.save_day_items = this.activeOrderItems.filter(item => {
						return moment(item.deliveryDate).isSame(moment(this.startDate), 'd');
					})
				}
			}
		},

		methods: {
			no_thanks() {
				this.$eventHub.$emit('cancel-set-date');
				$('#alreadyOrderedModal-' + this.index).modal('hide');
			},
			yes() {
				$('#alreadyOrderedModal-' + this.index).modal('hide');
			}
		}
	};
</script>
